/* eslint no-useless-catch: ['off'] */
import merge from 'lodash-es/merge'

export class LocalStorageProvider {
  constructor() {
    if (typeof window === 'undefined' || !window.localStorage) {
      return LocalStorageProvider.safeNull() as any
    }

    return this
  }

  get(key: string) {
    try {
      const value = localStorage.getItem(key)
      if (!value) {
        return null
      }
      return JSON.parse(value)
    } catch (error) {
      //
      // throw error
    }
  }

  set<T>(key: string, value: T) {
    try {
      localStorage.setItem(key, JSON.stringify(value))
    } catch (error) {
      //
      // throw error
    }
    return value
  }

  patch<T>(key: string, value: T) {
    const stored = this.get(key)
    this.set(key, merge(stored, value))
  }

  static safeNull() {
    return {
      get() {
        return null
      },
      set() {
        return null
      },
      patch() {
        return null
      },
    }
  }
}
